// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1XaFZ","label":"CategoryService_label__3Ar6E","location":"CategoryService_location__3vvW6"};